import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap-v5'
import axios from 'axios'

import { setCompanyVerificationMethod, setOpenVerification, setSubStep } from './redux/actions'
import { CompanyProfile } from '../../../svg/CompanyProfileIcon'
import { BankIcon } from '../../../svg/BankIIcon'
import { getIntegrationURLFromENV, getStoredEnv } from '../../../utils/getIntegrationURLFromENV'
import mutations from '../../../setup/graphql/mutations'
import { useMutation } from '@apollo/client'

interface Props {
  show: boolean
  handleClose: any
  goToStep: any
}

const UserVerification: FC<Props> = ({ show, handleClose, goToStep }: any) => {
  const dispatch = useDispatch()
  const history: any = useHistory()

  const coapplicant = useSelector((state: any) => state.coApplicant.co_applicant)
  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )
  const [updateShareholderKyc] = useMutation(mutations.UPDATE_SHAREHOLDER_KYC)
  const selectCompanyVerificationMethod = (method: number) => {
    dispatch(setCompanyVerificationMethod(method))
  }

  const connectMyInfo = async () => {
    // localStorage.setItem('coApplicationId', coapplicant?.id);
    localStorage.setItem('loanType', 'co-applicant-nets-kyc')
    localStorage.setItem('singpass', 'myinfo')
    const useNewAPI = process.env.REACT_APP_USE_NEW_MYINFO_API === 'true'

    // localStorage.setItem('coApplicationId', coapplicant?.id);
    localStorage.setItem('singpass', 'myinfo')

    if (useNewAPI) {
      const env = getStoredEnv()
      const integrationUrl = getIntegrationURLFromENV(env)
      const { data } = await axios.get(
        `${integrationUrl}myinfo/login?redirect_uri=${window.location.origin}/callback`
      )
      const { authorizeUrl, state, nonce, codeVerifier } = data as any

      await updateShareholderKyc({
        variables: {
          where: { id: coapplicant?.id },
          data: {
            metadata: {
              ...((coapplicant as any)?.metadata || {}),
              myInfoLogin: { state, nonce, codeVerifier },
            },
          },
        },
      })
      ;(window as any).location = authorizeUrl
      return
    }
  }

  const submitProfileVerification = () => {
    localStorage.setItem('coApplicationId', coapplicant?.id)
    if (companyVerificationMethod === 1) {
      connectMyInfo()
    } else {
      dispatch(setSubStep(3))
      history.replace(`/co-applicant-nets-kyc/${coapplicant.id}?subStep=3`)
    }
    handleClose()
  }

  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={show}
        centered // Bootstrap's built-in class for centering modals
      >
        <div className='modal-content'>
          <div className='d-flex flex-column align-items-center justify-content-center pt-6'>
            <CompanyProfile className='mb-4' />
            <h2 className='section-heading m-0 mt-4'>Verify User Profile</h2>
            <p className='text-muted fs-6'>
              Please select how you would like to verify your user profile
            </p>
          </div>

          <div className='d-block mx-5 my-10'>
            <div className='d-flex align-items-center border-bottom  min-h-145px'>
              <div className='fv-row fv-plugins-icon-container w-100'>
                <div className='row'>
                  <div className='col-lg-12 loan-application w-100'>
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center mb-10 verify-profile ${
                        companyVerificationMethod === 1 ? 'verify-profile-click' : ''
                      }`}
                      htmlFor='kt_create_account_form_account_type_personal'
                      onClick={() => selectCompanyVerificationMethod(1)}
                    >
                      {/* <KTSVG
                        path='/media/icons/duotune/communication/com005.svg'
                        className='svg-icon-3x me-5'
                      /> */}

                      {/* <span className='text-dark fw-bolder d-block fs-4 mb-2'>MyInfo Business with Singpass</span> */}
                      <BankIcon />
                      <span className='d-block fw-bold text-start ms-4'>
                        <span className='text-primary fw-bold d-block fs-2 mb-2'>
                          MyInfo with SingPass
                        </span>
                        <span className='text-color-10  fs-6'>Takes about 1-2 minutes</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-column gap-5 flex-center mx-5 my-10'>
            <button
              className='button button-primary  w-100'
              onClick={() => submitProfileVerification()}
            >
              Verify
            </button>
            <div className='line d-flex justify-content-center text-muted'>
              <span className='zIndex-1'>OR</span>
            </div>
            <button
              className='button button-outline-back w-100'
              onClick={() => {
                dispatch(setSubStep(1))
                dispatch(setCompanyVerificationMethod(1))
                dispatch(setOpenVerification(false))
              }}
            >
              Back
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default UserVerification
